import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';

import LeftPanelContent from './LeftPanelContent';
import LeftPanelTabs from './LeftPanelTabs';

import * as styles from './LeftPanel.css';

function LeftPanel(): JSX.Element {
  const [activeTab, setActiveTab] = useState<'settings' | 'design'>('settings');

  function handleTabClick(tab: 'settings' | 'design'): void {
    setActiveTab(tab);
  }

  return (
    <div className={styles.root}>
      {/* TODO (v1.0): Show Donation Form and Design tabs */}
      <LeftPanelTabs.Beta activeTab={activeTab} handleTabClick={handleTabClick} />
      <LeftPanelContent.Beta />
    </div>
  );
}

export default observer(LeftPanel);
